import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import React from "react";

import { AgentVersionStatus } from "src/agents/types";
import { Icon } from "src/base-components/Icon";

export const AgentVersionName: React.FC<{
  name: string;
  status: AgentVersionStatus;
}> = ({ name, status }) => {
  return (
    <div className="flex items-center gap-1">
      <AgentVersionStatusIndicator status={status} />
      {name}
    </div>
  );
};

export const AgentVersionStatusIndicator: React.FC<{
  status: AgentVersionStatus;
}> = ({ status }) => {
  return (
    <Icon
      color={status === "published" ? "text-green-400" : "text-yellow-400"}
      icon={faCircle}
      size="3xs"
    />
  );
};
